const getWalkMeCDNScript = (isProductionEnv) => {
    const apiKey = '92c7f295ca6c4cd48e4d4bc4ce23081d';
    return `https://cdn.walkme.com/users/${apiKey}/${isProductionEnv ? '' : 'test/'}walkme_${apiKey}_https.js`;
};

export default getWalkMeCDNScript;